<template>
  <div class="pb-5">

    <!-- my profile -->
    <div v-if="0" class="sp-block-user-info mb-5">
      <div class="pt-5 pb-4 container">

        <div class="pc-none pb-4 text-center">
          <span class="ui-icon size-80">
            <img src="/static/img/icon_user.jpeg">
          </span>
        </div>

        <div class="media">
          <div class="mr-5 mb-none">
            <span class="ui-icon size-80">
              <img src="/static/img/icon_user.jpeg">
            </span>
          </div>
          <div class="media-body mb-text-center">
            <div class="">
              <h5 class="op4">
                {{lg('',{
                  en: 'MY STABLE',
                  zh: '',
                })}}
              </h5>
              <!-- <h2>
                stable 23156394
              </h2> -->
            </div>
            <hr class="my-4">
            <div class="">
              <div class="row">
                <div class="col col-md-4">
                  <p class="op4 text-small">
                    {{lg('',{
                      en: 'THOROUGHBREDS',
                      zh: '',
                    })}}
                  </p>
                  <p>
                    <b>
                      <span v-if="!status_loading_list_lion_my">
                        {{list_lion_my.length}}
                      </span>
                      <span v-else>
                        -
                      </span>
                    </b>
                  </p>
                </div>

                <div class="col col-md-4">
                  <p class="op4 text-small">
                    {{lg('',{
                      en: 'TOTAL CAREER',
                      zh: '',
                    })}}
                  </p>
                  <p>
                    - / - / -
                  </p>
                </div>

                <div class="col col-md-4">
                  <p class="op4 text-small">
                    {{lg('',{
                      en: 'WIN RATE',
                      zh: '',
                    })}}
                  </p>
                  <p>
                    --%
                  </p>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- bg_stars -->
    <div class="ui-bg-stars">
    </div>

    <!-- banner -->
    <div class="ui-uni-banner">
      <div class="container ref">
        <div class="title-box">
          <h1>
            {{lg('',{
              en: 'My Collection',
              zh: '我的收藏',
            })}}
          </h1>
          <div>
            {{lg('',{
              en: 'All my lions',
              zh: '我的狮子',
            })}}
          </div>
        </div>

        <img 
          class="banner-img" 
          src="/static/img/bg_uni_banner_04.png" 
          style="height: 200px; right:10px; bottom: -18px;"
        >
      </div>
    </div>

    <div class="container my-5">
      <div class="sp-list-main">
        <div
           v-for="(item,index) of list_lion_my"
          :key="index"
          class="sp-item"
          >
          <lionItem
            :data="item"
            :cfg_show_name_row="true"
            :cfg_show_price_row="true"
            :cfg_give_name_available="true"
            :cfg_hide_header="true"
          />
        </div>
      </div>
    </div>

    <!-- <div class="container pt-5">
      <div class="ui-card px-4 py-3">
        <h6 class="mb-0">
          {{lg('',{
            en: 'My BNB',
            zh: '',
          })}}
        </h6>
        <h2 class="mb-0">
          BNB {{my_balance_bnb | qfw}}
        </h2>
      </div>
    </div> -->

    <div class="container">
      <div class="ui-card border px-4 py-3 mt-3">
        <!-- <span 
          @click="action_createHorse()"
          class="btn btn-primary btn-sm mr-3"
          >
          {{lg('',{
            en: 'Mint Token (Test)',
            zh: '铸造(测试)',
          })}}
        </span>
        <span 
          @click="action_createMaleHorse()"
          class="btn btn-primary btn-sm mr-3"
          >
          {{lg('',{
            en: 'Mint Lion',
            zh: '铸造狮子',
          })}}
        </span>
        <span 
          @click="action_createFemaleHorse()"
          class="btn btn-primary btn-sm mr-3"
          >
          {{lg('',{
            en: 'Mint FeMale Lion (Test)',
            zh: '铸造母狮子',
          })}}
        </span> -->
        <!-- <span 
          @click="action_createMaleHorse()"
          class="btn btn-primary btn-sm mr-3"
          >
          Mint Male Lion (Test)
        </span> -->
      </div>
    </div>

    <!-- <div class="m-4">
      <button @click="demoAnimationDraw()">AnimationDraw</button>
      <button @click="demoAnimationBorn()">AnimationBorn</button>
    </div> -->

    <!-- ↓ hide -->
    <div v-if="0" class="container">

      <h4 class="mt-5 mb-3 op4">
        {{lg('',{
          en: 'All Lions',
          zh: '',
        })}}
      </h4>
      <div>
        <div v-for="(item,index) of list_lion_my" :key="index" class="mb-3">
          <horseItem 
            :data="item"
            :cfg_give_name_available="true"
          />
        </div>
      </div>

      <div class="pt-5 text-center">
        <router-link 
          :to="'/'"
          class="btn btn-primary"
          >
          {{lg('',{
            en: 'OWN A LION',
            zh: '',
          })}}
        </router-link>
      </div>
    </div>


    <!-- <popupBreed/> -->
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import horseItem from '../_cp_busi/horse_item.vue'
import lionItem from '@/views/_cp_busi/lion_item.vue'

export default {
  name: 'myPage',
  components: {
    horseItem,
    lionItem,
  },
  props: [],
  data() {
    return {
      list_lion_my: [],
      status_loading_list_lion_my: false,
      my_balance_bnb: '-',

      status_show_popup_breed: false,
    }
  },
  computed: {
    address_my(){
      return this.$store.state.web3.account
    },
  },
  watch: {
    address_my(val){
      if(val){
        this.run()
      }
    },
  },
  methods: {
    ...mapActions([
      'getUserAllHorse',
      'getUserWalletBalance',
      'createHorse',
      'createMaleHorse',
      'createFemaleHorse',
      'createMaleHorse`',
    ]),

    demoAnimationDraw(){
      this.$store.commit('setDataBusKey',{
        data_popup_show_new_draw: {},
      })
    },
    demoAnimationBorn(){
      this.$store.commit('setDataBusKey',{
        data_popup_show_new_born: {},
      })
    },

    uiPopupBreed(item){
      this.status_show_popup_breed = true
    },

    async action_createHorse(){
      let v = this
      if(!v.address_my){
        return
      }

      await v.createHorse({
        address_my: v.address_my,
      })
    },
    async action_createMaleHorse(){
      let v = this
      if(!v.address_my){
        return
      }

      await v.createMaleHorse({
        address_my: v.address_my,
      })
    },
    async action_createFemaleHorse(){
      let v = this
      if(!v.address_my){
        return
      }

      await v.createFemaleHorse({
        address_my: v.address_my,
      })
    },

    async getMyBalance(){
      let v = this
      if(!v.address_my){
        return
      }
      const res = await v.getUserWalletBalance({
        address_my: v.address_my,
      })

      v.my_balance_bnb = res
    },
    async listMyHorse(){
      let v = this
      if(!v.address_my){
        return
      }
      v.status_loading_list_lion_my = true
      const res = await v.getUserAllHorse({
        address_my: v.address_my,
      })

      // console.log('@@@@@@-------------------------')
      // console.log(res)

      let res_new = res.map(item => {
        let item_new = v.transHorseData(item)
        item_new.is_my = true
        return item_new
      })
      v.status_loading_list_lion_my = false

      v.list_lion_my = res_new
      v.$store.commit('setAppKey',{
        data_my_lion: JSON.parse(JSON.stringify(v.list_lion_my))
      })
    },
    run(){
      this.listMyHorse()
      this.getMyBalance()
    },
  },
  created() {
    
    this.run()
    return
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  .sp-block-user-info{
    background: linear-gradient(180deg, transparent, transparent, rgba(240, 248, 255, 0.04));
  }
</style>